import styled from 'styled-components';

export const GroupSkeletonStyled = styled.div`

  .groupSkeleton {
    &__groupCard {
      background-color: ${props => props.theme.uiColors.boxBgColor01};
      border: 1px solid ${props => props.theme.uiColors.tableListRowBorder};
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      padding: 16px;
      gap: 12px;
    }

    &__groupHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }

    &__groupItem {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 8px 0;
    border-top: 1px solid ${props => props.theme.uiColors.multiFlightSectionBorder};

      &:first-of-type {
        border-top: none;
      }

      &--left, &--right {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      &--right {
        align-items: flex-end;
      }
    }

    &__deleteButton {
      margin-top: 12px;
    }
}
`;
